import type { ResultsType } from "../calculadora-veiculo-eletrico_d";

export function sanitizeNumericValue(value: string): number {
  if (!value || value.trim() === '') return NaN;
  
  let cleaned = value.trim();
  
  if (cleaned.includes(',')) {
    cleaned = cleaned.replace(/\./g, '');
  }
  
  cleaned = cleaned.replace(',', '.');
  cleaned = cleaned.replace(/[^\d.-]/g, '');
  
  return parseFloat(cleaned);
}

export function formatNumericInput(value: string): string {
  let formatted = value.replace(/[^\d.,]/g, '');
  
  const commaCount = (formatted.match(/,/g) || []).length;
  const dotCount = (formatted.match(/\./g) || []).length;
  
  if (commaCount > 1) {
    const parts = formatted.split(',');
    formatted = parts[0] + ',' + parts.slice(1).join('');
  }
  
  if (dotCount > 1) {
    const parts = formatted.split('.');
    formatted = parts[0] + '.' + parts.slice(1).join('');
  }
  
  return formatted;
}

export function calcularComparativoVeiculos(
  distanciaAnual: number,
  consumoCombustivel: number,
  precoCombustivel: number,
  consumoEletrico: number,
  precoEnergia: number
): ResultsType {
  
  const distanciaMensal = distanciaAnual / 12;
  
  const litrosMes = distanciaMensal / consumoCombustivel;
  const custoMensalCombustivel = litrosMes * precoCombustivel;
  const custoAnualCombustivel = custoMensalCombustivel * 12;
  const custoPorKmCombustivel = precoCombustivel / consumoCombustivel;
  
  const kwhMes = distanciaMensal / consumoEletrico;
  const custoMensalEletrico = kwhMes * precoEnergia;
  const custoAnualEletrico = custoMensalEletrico * 12;
  const custoPorKmEletrico = precoEnergia / consumoEletrico;
  
  const economiaMensal = custoMensalCombustivel - custoMensalEletrico;
  const economiaAnual = economiaMensal * 12;
  const percentualEconomia = ((economiaMensal / custoMensalCombustivel) * 100);
  
  const dadosMensais = [];
  for (let mes = 1; mes <= 12; mes++) {
    dadosMensais.push({
      month: mes,
      fuelAccumulated: Number((custoMensalCombustivel * mes).toFixed(2)),
      electricAccumulated: Number((custoMensalEletrico * mes).toFixed(2)),
      savingsAccumulated: Number((economiaMensal * mes).toFixed(2))
    });
  }
  
  return {
    fuelMonthlyConsumption: Number(litrosMes.toFixed(2)),
    fuelMonthlyCost: Number(custoMensalCombustivel.toFixed(2)),
    fuelAnnualCost: Number(custoAnualCombustivel.toFixed(2)),
    
    electricMonthlyConsumption: Number(kwhMes.toFixed(2)),
    electricMonthlyCost: Number(custoMensalEletrico.toFixed(2)),
    electricAnnualCost: Number(custoAnualEletrico.toFixed(2)),
    
    monthlySavings: Number(economiaMensal.toFixed(2)),
    annualSavings: Number(economiaAnual.toFixed(2)),
    savingsPercentage: Number(percentualEconomia.toFixed(2)),
    costPerKmFuel: Number(custoPorKmCombustivel.toFixed(4)),
    costPerKmElectric: Number(custoPorKmEletrico.toFixed(4)),
    
    monthlyData: dadosMensais
  };
}